import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { init } from './state'
import { JoinDefaultProps } from './types'
import { Main } from '../../../components'
import { FormattedMessage } from 'react-intl'

export function Initialize({ ...initProps }: JoinDefaultProps) {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(init(initProps))
  }, [dispatch, initProps])

  return (
    <Main.Container>
      <Main.Title>
        <FormattedMessage
          id="boarding.organization.join.initialize.title"
          defaultMessage="Loading..."
          values={{}}
        />
      </Main.Title>
    </Main.Container>
  )
}
